/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

// Polyfills
import 'whatwg-fetch';

// Scripts
// =============================================================================

import PageStatus from './scripts/page-status';
import HeaderMenuMobile from './scripts/header-menu-mobile';
import HighlightButton from './scripts/highlight-button';
import OverflowSwipeIcon from './scripts/overflow-swipe-icon';
import HeaderContrastToggle from './scripts/header-contrast-toggle';

// Sections
import Accordion from './scripts/accordion';

const scripts = [
  PageStatus,
  HeaderMenuMobile,
  HighlightButton,
  Accordion,
  OverflowSwipeIcon,
  HeaderContrastToggle
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});

// Vendors
// =============================================================================

// import './vendors/smooth-scroll';
